module.exports = __webpack_public_path__ + "img/banner-index.be5f071a.png";